import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WebChannelAnalyticsSection } from './WebChannelAnalyticsSection'
import { WebChannelCmpSection } from './WebChannelCmpSection'
/**
* Class WebChannelAnalyticsConfig
*  Публичная конфигурация веб-аналитики и cookie-согласия витрины. Секреты сквозной аналитики (OAuth-токен, цели) сюда не попадают
*/
export class WebChannelAnalyticsConfig extends ActiveModel {

  /**
  * analytics
  * Настройки счётчика веб-аналитики<br>  */
  @ActiveField({
    factory: [WebChannelAnalyticsSection, () => WebChannelAnalyticsSection.create()]
  })
  analytics: WebChannelAnalyticsSection = WebChannelAnalyticsSection.create()


  /**
  * cmp
  * Настройки cookie-согласия (CMP)<br>  */
  @ActiveField({
    factory: [WebChannelCmpSection, () => WebChannelCmpSection.create()]
  })
  cmp: WebChannelCmpSection = WebChannelCmpSection.create()
}
